export default __webpack_public_path__ + "static/media/citation-print-zebra.e9e26ff1.svg";